(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.resi.controller.inrev-nav
  (:require
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]))

(defn row-ui-props
  [labels]
  {:cell-props (concat [nil]
                       (->> labels
                            (mapv (fn [_]
                                    {:style {:text-align "right"}}))))})

(defn inrev-nav
  [{:keys [report-data] :as props}]
  (report-ctl/with-footnote
   props
   :inrev-nav-footnotes
   (:inrev-nav report-data)))
